(function ($) {
    $.fn.attachmentsDialog = function () {
        let $imageBoxDialog;
        let _identifier;
        let $documentElement;
        let $currentAttachmentKey;
        let $errorImage;
        let $imageTarget;
        let $imageContainer;
        let $navigationButtons = {'previous': null, 'next':  null};
        let $attachmentList = {};
        let $zooming = {
            level: 100,
            min: 100,
            max: 500,
            increment: 50,
            isDragging: false,
            startX: null,
            startY: null,
            scrollLeft: null,
            scrollTop: null,
        }
        let $attachmentListKeys = [];
        let $changedAttachmentLists = [];
        let $rotationAngle = 0;
        let $filename = '';
        let $editIcon = ' <span class="icon-edit" data-cy="edit-icon" style="line-height: 1em"></span>';
        let $isConfirmDialogOn = false;
        let $isInputFieldOn = false;
        let $isIframe = false;
        let $isEscapeKeyPressed = false;

        const prepareToLoad = () => {
            const loadingImage = $imageBoxDialog.find('.imageCanvas-js').data('loading-image') ?? '';
            $imageTarget.attr('src', loadingImage).css('opacity', 0.1);
            $imageBoxDialog.find('.title').addClass('hidden-during-loading');
            $imageBoxDialog.find('.hidden-during-loading').css('visibility', 'hidden');

            $($navigationButtons.previous)?.prop('disabled', true);
            $($navigationButtons.next)?.prop('disabled', true);

            $rotationAngle = 0;

            $imageTarget.css({
                'left': '',
                'top': ''
            });
        };

        const loadTargetAttachment = (targetAttachmentId) => {
            if (undefined === $attachmentList[targetAttachmentId]) {
                throw new Error(`Image ${targetAttachmentId} not found`);
            } else if (!$imageBoxDialog) {
                throw new Error('Error: $imageBoxDialog is not defined.');
            }

            prepareToLoad();

            $currentAttachmentKey = $attachmentListKeys.indexOf(targetAttachmentId);

            const $attachment = $attachmentList[targetAttachmentId];
            const { link,
                filename,
                isEmail,
                isPublic,
                extension,
                filesize,
                fileModified,
                showDeleteButton,
                allowChange,
                mimeType
            } = $attachment;

            /*
             * As loadAttachmentImage is async loading the image
             * we need a callback to be called just after displaying the image.
             */
            const postLoadActionsCallBack = () => {
                postLoadActions({
                    downloadUrl: link,
                    title: filename,
                    size: filesize,
                    modified: fileModified,
                    isEmail: isEmail,
                    isPublic: isPublic,
                    isDeleteButtonVisible: showDeleteButton,
                    extension: extension,
                    allowChange: allowChange,
                    mimeType: mimeType,
                });
            }
            loadAttachmentImage(link, postLoadActionsCallBack);
        };

        const loadAttachmentImage = (imageURL, callback) => {
            resetImageZoom();

            const image = new Image();
            image.onload = () => {
                $imageTarget.attr('src', imageURL).animate({opacity: 1}, 400);
                callback();
            };
            image.onerror = () => {
                /*
                 * When an error happen show the user it was not possible to load the
                 * image but allow them to download and navigate the attachment
                 */
                $imageTarget.attr('src', getErrorImage()).css({opacity: 1});
                callback();
                $($documentElement).find('.hidden-during-loading').css('visibility', 'hidden');
                $($documentElement).find('#attachmentModalPrev, #attachmentModalNext').css('visibility', 'visible');
            };
            image.src = imageURL;
        };

        const getErrorImage = (text) => {
            if (!$errorImage) {
                const canvas = document.createElement('canvas');

                const $content = $($documentElement).find('#imageBoxDialog_redesigned .content');
                canvas.width = $content.width();
                canvas.height = $content.height();

                const context = canvas.getContext('2d');
                context.fillStyle = '#FFFFFF';
                context.fillRect(0, 0, canvas.width, canvas.height);

                context.fillStyle = '#000000';
                context.font = '32pt Arial';
                context.textAlign = 'center';
                context.textBaseline = 'middle';

                context.fillText('Not possible to load the image', canvas.width / 2, canvas.height / 2);

                $errorImage = canvas.toDataURL('image/png');
            }

            return $errorImage;
        }

        const postLoadActions = (...args) => {
            const [{
                downloadUrl,
                title,
                size,
                modified,
                isEmail,
                isPublic,
                isDeleteButtonVisible,
                extension,
                allowChange,
                mimeType,
            }] = args;

            // showEditIcon
            let editIconHTML = allowChange ? $editIcon : '';

            const $imageBoxDialogTitle = $imageBoxDialog.find('.title');
            $imageBoxDialogTitle
                .data('filename', title)
                .text(title)
                .addClass('imageViewerAttachmentName')
                .attr('extension', extension)
                .attr('allowChange', allowChange);

            if (allowChange) {
                $imageBoxDialogTitle.append(editIconHTML);
            } else {
                $imageBoxDialogTitle.css('cursor', 'default')
            }

            $imageBoxDialog.find('#labelAttachmentExifData').text(`${size}, ${modified}`);
            $imageBoxDialog.find('.download-js').attr('href', `${downloadUrl}&download=1`);
            $imageBoxDialog.find('.imageViewerAttachmentEmail').prop('checked', isEmail);
            $imageBoxDialog.find('.imageViewerAttachmentPublic').prop('checked', isPublic);

            $($documentElement).find('#attachmentDeleteButton').toggle(!!isDeleteButtonVisible);
            $($documentElement).find('.hidden-during-loading').css('visibility', 'visible');

            toggleNavigationButtons();
            disableAttachmentOptions();
            toggleAttachmentOptions();

            /*
             * We have a front-end solution to rotate SVG but not on backend so we decided to
             * do not rotate SVG. If we implement it in the future, we still ahve the front-end solution
             * We have a back-end solution to save animated gif/webp but not on front-end, when rotating it rotate only one frame.
             */
            ['image/svg+xml', 'image/gif', 'image/webp', 'image/heif','image/heic'].includes(mimeType)
                ? $($documentElement).find('#image-rotation').hide()
                : $($documentElement).find('#image-rotation').show();
        };

        const disableAttachmentOptions = () => {
            const $attachmentTable = $($documentElement).find("#attachmentTable");

            // Helper function to check if any element matching the selector is disabled
            function isAnyElementDisabled(selector) {
                return $attachmentTable.find(selector).is(':disabled');
            }

            // Disable or enable the options based on the state of elements in the attachment table
            const isEmailDisabled = isAnyElementDisabled(`[class^="attachmentEmail"]`);
            $imageBoxDialog.find('.imageViewerAttachmentEmail').prop('disabled', isEmailDisabled);

            const isPublicDisabled = isAnyElementDisabled(`[class^="attachmentPublic"]`);
            $imageBoxDialog.find('.imageViewerAttachmentPublic').prop('disabled', isPublicDisabled);
        }

        const toggleAttachmentOptions = function() {
            const tmpName = $attachmentListKeys[$currentAttachmentKey];

            // Check for the element with class 'attachmentEmail' and the specified data-tmp-name
            const isEmailDisplay = $($documentElement).find(`.attachmentEmail[data-tmp-name="${tmpName}"]`).filter(function() {
                return !$(this).parent().hasClass('hide');
            }).length > 0;

            // Check for the element with class 'attachmentPublic' and the specified data-tmp-name
            const isPublicDisplay = $($documentElement).find(`.attachmentPublic[data-tmp-name="${tmpName}"]`).filter(function() {
                return !$(this).parent().hasClass('hide');
            }).length > 0;

            // Default display flag
            const isDefaultDisplay = false;

            // Toggle visibility based on the conditions
            $imageBoxDialog.find('.attachmentEmailWrapper').toggle(isEmailDisplay);
            $imageBoxDialog.find('.attachmentPublicWrapper').toggle(isPublicDisplay);
            $imageBoxDialog.find('.attachmentIsDefaultWrapper').toggle(isDefaultDisplay);
        };

        const toggleNavigationButtons = () => {
            $($navigationButtons.previous)?.prop('disabled', false)
            $($navigationButtons.next)?.prop('disabled', false)

            if ($currentAttachmentKey === 0) {
                $($navigationButtons.previous)?.prop('disabled', true)
            }

            if ($currentAttachmentKey === $attachmentListKeys.length - 1) {
                $($navigationButtons.next)?.prop('disabled', true)
            }
        };

        const openDialog = (tmpImageName) => {
            $imageBoxDialog.fadeIn(() => {
                bindEvents()
            });
            //because there are different IDs in different pages.
            document.querySelectorAll('[id^="attachmentTable"], [id^="attachmentFilesContainer"], #gridViewContainer').forEach(function(el) {
                el.classList.add('blur-attachmentTable');
            });

        };

        const loadAttachmentList = () => {
            let view = $('table#attachmentTable').is(':visible') ? 'list' : 'grid';
            // Get the attachments from the list or the grid
            if (view === 'list') {
                if ($imageBoxDialog.attr('id') === "imageBoxDialog_redesigned") {
                    filter = 'table#attachmentTable tr:not(.attachment) a.dialogAttachmentItem';
                } else {
                    filter = 'table[id^="attachmentTable"]:not(#attachmentTable) tr:not(.attachment) a.dialogAttachmentItem';
                }
            } else if (view === 'grid') {
                // Modules can have multiple grid views, make sure we are filtering through the right one
                if ($imageBoxDialog.attr('id') === "imageBoxDialog_redesigned") {
                    filter = 'div#attachmentFilesContainer div.dialogAttachmentItem';
                } else {
                    filter = 'div[id^="attachmentFilesContainer"]:not(#attachmentFilesContainer) div.dialogAttachmentItem'
                }
            }

            const attachments = $(filter);

            attachments.each(function() {
                const tmpName = $(this).attr('data-tmpname');
                if ($(this).attr('data-is-image')) {
                    $attachmentList[tmpName] = {
                        'filename': $(this).attr('data-filename'),
                        'link': $(this).attr('data-link'),
                        'extension': $(this).attr('data-extension'),
                        'elementId': $(this).attr('data-elementid') ?? '',
                        'isPublic': $($documentElement).find(`.attachmentPublic[data-tmp-name="${tmpName}"]`).prop('checked') ?? false,
                        'isEmail': $($documentElement).find(`.attachmentEmail[data-tmp-name="${tmpName}"]`).prop('checked') ?? false,
                        'filesize': $(this).attr('data-file-size'),
                        'fileModified': $(this).attr('data-file-modified'),
                        'showDeleteButton': $(this).attr('data-show-delete-button'),
                        'allowChange': $(this).attr('data-allow-change'),
                        'mimeType': $(this).attr('data-mime-type'),
                        'id': $(this).attr('id'),
                        'rotated': null,
                        'view' : view,
                        'keyid': (view === 'list' ? $(this).parent().parent('tr').attr('key') : $(this).attr('data-index'))
                    };
                    $attachmentListKeys.push(tmpName);
                }
            });
        };

        const adjustImagePositionAfterZooming = () => {
            $imageContainer.scrollTop($imageContainer.scrollTop() > 0 ? $imageContainer.scrollTop() : 1);
            $imageContainer.scrollLeft($imageContainer.scrollLeft() > 0 ? $imageContainer.scrollLeft() : 1);

            const isScrollingBarVisible = {
                'horizontal': $imageContainer[0].scrollWidth > $imageContainer[0].clientWidth || $imageContainer.scrollLeft() > 0,
                'vertical': $imageContainer[0].scrollHeight > $imageContainer[0].clientHeight || $imageContainer.scrollTop() > 0
            }

            $imageTarget.css({
                'left': '',
                'top': ''
            });

            $imageTarget.removeClass('zoom-scrolling-x zoom-scrolling-y zoom-scrolling-xy');
            if (isScrollingBarVisible.vertical && isScrollingBarVisible.horizontal) {
                $imageTarget.addClass('zoom-scrolling-xy');
            } else if (isScrollingBarVisible.vertical) {
                $imageTarget.addClass('zoom-scrolling-y');
            } else if (isScrollingBarVisible.horizontal) {
                $imageTarget.addClass('zoom-scrolling-x');
            }

            const topDistance = ($imageContainer.offset().top - $imageTarget.offset().top) - $imageContainer.scrollTop();
            const leftDistance = ($imageContainer.offset().left - $imageTarget.offset().left) - $imageContainer.scrollLeft();

            if ($imageTarget.hasClass('zoom-scrolling-x') || $imageTarget.hasClass('zoom-scrolling-xy')) {
                if (leftDistance > 0 ) {
                    $imageTarget.css('left', '0px');
                } else if (leftDistance < 0 ) {
                    $imageTarget.css('left', `${leftDistance}px`);
                }
            }

            if ($imageTarget.hasClass('zoom-scrolling-y') || $imageTarget.hasClass('zoom-scrolling-xy')) {
                if (topDistance > 0 ) {
                    $imageTarget.css('top', '0px');
                } else if (topDistance < 0 ) {
                    $imageTarget.css('top', `${topDistance}px`);
                }
            }
        };

        const applyImageZoomIn = () => {
            if ($zooming.level < $zooming.max) {
                const containerCenterX = $imageContainer.width() / 2;
                const containerCenterY = $imageContainer.height() / 2;

                const imageOffsetX = containerCenterX + $imageContainer.scrollLeft();
                const imageOffsetY = containerCenterY + $imageContainer.scrollTop();

                $zooming.level += $zooming.increment;

                applyZoom();

                if ($imageContainer[0].scrollWidth > $imageContainer.width()) {
                    const newImageOffsetX = imageOffsetX * ($zooming.level / ($zooming.level - $zooming.increment));
                    $imageContainer.scrollLeft(newImageOffsetX - containerCenterX);
                }

                if ($imageContainer[0].scrollHeight > $imageContainer.height()) {
                    const newImageOffsetY = imageOffsetY * ($zooming.level / ($zooming.level - $zooming.increment));
                    $imageContainer.scrollTop(newImageOffsetY - containerCenterY);
                }

                adjustImagePositionAfterZooming();
                handleZoomButtons();
            }
        };

        const applyImageZoomOut = () => {
            if ($zooming.level > $zooming.min) {
                const containerCenterX = $imageContainer.width() / 2;
                const containerCenterY = $imageContainer.height() / 2;

                const imageOffsetX = containerCenterX + $imageContainer.scrollLeft();
                const imageOffsetY = containerCenterY + $imageContainer.scrollTop();

                $zooming.level -= $zooming.increment;

                applyZoom();

                if ($imageContainer[0].scrollWidth > $imageContainer.width()) {
                    const newImageOffsetX = imageOffsetX * ($zooming.level / ($zooming.level + $zooming.increment));
                    $imageContainer.scrollLeft(newImageOffsetX - containerCenterX);
                }

                if ($imageContainer[0].scrollHeight > $imageContainer.height()) {
                    const newImageOffsetY = imageOffsetY * ($zooming.level / ($zooming.level + $zooming.increment));
                    $imageContainer.scrollTop(newImageOffsetY - containerCenterY);
                }

                adjustImagePositionAfterZooming();
                handleZoomButtons();
            } else {
                resetImageZoom();
            }
        };

        const resetImageZoom = () => {
            $zooming.level = $zooming.min;
            applyZoom();
            $imageContainer.scrollLeft(0);
            $imageContainer.scrollTop(0);
            adjustImagePositionAfterZooming();
            handleZoomButtons();
        };

        const handleZoomButtons = () => {
            $($documentElement).find('.zoom-in, .zoom-out, .zoom-reset').removeClass('zoomDisabled');

            if ($zooming.level === $zooming.max) {
                $($documentElement).find('.zoom-in').addClass('zoomDisabled');
            } else if ($zooming.level === $zooming.min) {
                $($documentElement).find('.zoom-out, .zoom-reset').addClass('zoomDisabled');
            }
        }

        const bindNavigationEvents = () => {
            $($navigationButtons.previous)?.on(`click.${_identifier}`, loadPreviousAttachment);
            $($navigationButtons.next)?.on(`click.${_identifier}`, loadNextAttachment);
        };

        const bindIsEmailAttachment = () => {
            const $imageViewerAttachmentEmail = $($documentElement).find('.imageViewerAttachmentEmail');
            const $imageViewerAttachmentPublic = $($documentElement).find('.imageViewerAttachmentPublic');
            $imageViewerAttachmentEmail.on(`click.${_identifier}`, function () {
                let checked = $(this).is(':checked');
                //update attachment List Item
                const itemKey = $attachmentListKeys[$currentAttachmentKey];
                $($documentElement).find(`.attachmentEmail[data-tmp-name="${itemKey}"]`)
                    .prop('checked', checked)
                    .trigger("makeAttachmentEmail");
                $($documentElement).find(`[name="attachmentEmail[${itemKey}]"]`).val(checked ? 'on' : 'off');

                // Update email respectively
                if (checked && !$imageViewerAttachmentPublic.is(':checked')) {
                    // update email respectively
                    $imageViewerAttachmentPublic.prop('checked', checked);
                    // update settings on UI
                    $($documentElement).find(`.attachmentPublic[data-tmp-name="${itemKey}"]`).prop('checked', checked);
                    $($documentElement).find(`[name="attachmentPublic[${itemKey}]"]`).val('on');
                }
            })
        };

        const bindIsPublicAttachment = () => {
            const $imageViewerAttachmentEmail = $($documentElement).find('.imageViewerAttachmentEmail');
            const $imageViewerAttachmentPublic = $($documentElement).find('.imageViewerAttachmentPublic');
            $imageViewerAttachmentPublic.on(`click.${_identifier}`, function () {
                let checked = $(this).is(':checked');
                //update attachment List Item
                const itemKey = $attachmentListKeys[$currentAttachmentKey];
                $($documentElement).find(`.attachmentPublic[data-tmp-name="${itemKey}"]`)
                    .prop('checked', checked)
                    .trigger("makeAttachmentPublic");
                $($documentElement).find(`[name="attachmentPublic[${itemKey}]"]`).val(checked ? 'on' : 'off');

                // Update email respectively
                if (!checked && $imageViewerAttachmentEmail.is(':checked')) {
                    // update email respectively
                    $imageViewerAttachmentEmail.prop('checked', checked);
                    // update settings on UI
                    $($documentElement).find(`.attachmentEmail[data-tmp-name="${itemKey}"]`).prop('checked', checked);
                    $($documentElement).find(`[name="attachmentEmail[${itemKey}]"]`).val('off');
                }
            })
        };

        const bindFullscreen = () =>  {
            $($documentElement).find('.fullscreen-js').on(`click.${_identifier}`, propFullScreen);
        };

        const propFullScreen = () => {
            const $lightbox = $($documentElement).find('.lightbox');
            $lightbox.toggleClass('fullPage');

            let navigationButtonPosition;
            let iconClasses = {'toBeRemoved': null, 'toBeAdded': null};

            // If it has fullPage class it means it is in full screen mode
            if ($lightbox.hasClass('fullPage') && !$isConfirmDialogOn) {
                $('body').css('overflow', 'hidden');
                iconClasses.toBeRemoved = 'icon-fullscreen-expand';
                iconClasses.toBeAdded = 'icon-fullscreen-collapse';
                navigationButtonPosition = '70px';
            } else {
                $('body').css('overflow', 'auto');
                iconClasses.toBeRemoved = 'icon-fullscreen-collapse';
                iconClasses.toBeAdded = 'icon-fullscreen-expand';
                navigationButtonPosition = '-70px';
            }

            $($documentElement).find('#fullscreenIconElement').removeClass(iconClasses.toBeRemoved).addClass(iconClasses.toBeAdded);
            $($documentElement).find('.modalNavigation.next').css('right', navigationButtonPosition);
            $($documentElement).find('.modalNavigation.previous').css('left', navigationButtonPosition);
        };

        const closeDialog = async () => {
            await saveAttachment();

            refreshAttachments($changedAttachmentLists);

            // Not removing full screen when open the dialog again, will directly open on full screen mode
            if ($($documentElement).find('.lightbox').hasClass('fullPage')) {
                propFullScreen();
            }
            $($documentElement).find('div[class="dialogBox"]').remove();
            //because there are different IDs in different pages.
            document.querySelectorAll('[id^="attachmentTable"], [id^="attachmentFilesContainer"], #gridViewContainer').forEach(function(el) {
                el.classList.remove('blur-attachmentTable');
            });

            destroy();
        };

        /*
          Checks if the next or previous navigation button is enabled
        */
        const isNavigationDisabled = (navigationAction) => {
            return $($navigationButtons[navigationAction])?.prop('disabled');
        };

        const bindKeydownEvents = () => {
            const keydownEventsCallback = (event) => {
                const key = event.key || String.fromCharCode(event.keyCode);

                switch (key) {
                case 'Escape':
                case '27':
                    $isEscapeKeyPressed = true;
                    closeDialog();
                    break;
                case 'ArrowLeft':
                case '37':
                    if ($isConfirmDialogOn || $isInputFieldOn || isNavigationDisabled('previous')) return;
                    loadPreviousAttachment();
                    break;
                case 'ArrowRight':
                case '39':
                    if ($isConfirmDialogOn || $isInputFieldOn || isNavigationDisabled('next')) return;
                    loadNextAttachment();
                    break;
                }
            };

            $($documentElement).on(`keydown.${_identifier}`, keydownEventsCallback);
        };

        const bindZoomEvents = () => {
            $($documentElement).find('#zoomPanel .zoom-in').on(`click.${_identifier}`, applyImageZoomIn);
            $($documentElement).find('#zoomPanel .zoom-out').on(`click.${_identifier}`, applyImageZoomOut);
            $($documentElement).find('#zoomPanel .zoom-reset').on(`click.${_identifier}`, resetImageZoom);

            $($documentElement).find('#lightboxImage, .imageCanvas-js').on(`wheel.${_identifier}`, function(event) {
                event.preventDefault();
                // If zoom panel is hidden we do not zoom via scrolling too
                if ($($documentElement).find('#zoomPanel').css('visibility') === 'hidden') return;

                if (event.originalEvent.deltaY < 0) {
                    applyImageZoomIn();
                } else {
                    applyImageZoomOut();
                }
            });
        };

        const bindImageRotation = () => {
            $($documentElement).find('#image-rotation .rotate-left').on(`click.${_identifier}`, () => applyRotation(-90));
            $($documentElement).find('#image-rotation .rotate-right').on(`click.${_identifier}`, () => applyRotation(90));
        };

        const applyZoom = () => {
            const currentScale = $zooming.level / 100;
            $imageTarget.css('transform', `scale(${currentScale})`);
        };

        const applyRotation = (degree) => {
            resetImageZoom();

            // When completing an entire loop, we reset the rotation to 0 to accurately maintain the true angle
            $rotationAngle += degree;
            if ($rotationAngle % 360 === 0) {
                $rotationAngle = 0;
            }

            getBase64RotatedImage(degree).then(base64Image => {
                $imageTarget.attr('src', base64Image).css('transform','');
                //update rotated key
                const itemKey = $attachmentListKeys[$currentAttachmentKey];
                const date = Date.now();
                $attachmentList[itemKey].rotated = date;
                let link = updateAttachmentLink(itemKey, date);
                //list view
                $($documentElement).find("#hrefAttachment_"+$attachmentList[itemKey].keyid).attr('data-link',link);
                $($documentElement).find("#hrefAttachment_"+$attachmentList[itemKey].keyid).attr('data-src',link);
                //grid view
                //replace thumbnail
                let thumbImageLink = link;
                const regex = /[?&]thumbnail=0/;
                thumbImageLink = thumbImageLink.replace(regex, "&thumbnail=1");

                $($documentElement).find("#attachmentThumbnail"+$attachmentList[itemKey].keyid).attr('data-link',link);
                $($documentElement).find("#attachmentThumbnail"+$attachmentList[itemKey].keyid).attr('data-src',link);
                $($documentElement).find("#attachmentThumbnail"+$attachmentList[itemKey].keyid + ' > a' + ' > img').attr('src',thumbImageLink);

                const attachment = $attachmentList[itemKey];
                if (attachment.allowChange !== '') {
                    getAttachmentEditChanges(attachment, itemKey);
                }
            }).catch(error => {
                console.error('Error generating base64 image:', error);
                throw new Error('Not possible to rotate the image.');
            });
        };

        const getAttachmentEditChanges = (attachmentData, itemKey) => {
            // Public always has to be true if Email is true
            attachmentData.isPublic = attachmentData.isEmail ? true : attachmentData.isPublic;
            let index = $changedAttachmentLists.findIndex(item => item.itemKey === itemKey);
            if (index !== -1) {
                $changedAttachmentLists[index].isEmail = attachmentData.isEmail;
                $changedAttachmentLists[index].isPublic = attachmentData.isPublic;
                $changedAttachmentLists[index].filename = attachmentData.filename;
                $changedAttachmentLists[index].attachmentName = attachmentData.filename.replace(/\.[^/.]+$/, "");
            } else {
                $changedAttachmentLists.push({
                    itemKey,
                    isEmail: attachmentData.isEmail,
                    isPublic: attachmentData.isPublic,
                    filename: attachmentData.filename,
                    attachmentName: attachmentData.filename.replace(/\.[^/.]+$/, "")
                });
            }
        }

        const bindEvents = () => {
            bindNavigationEvents();
            bindFullscreen();
            bindCloseDialogButton();
            bindKeydownEvents();
            bindZoomEvents();
            bindDeleteAttachment();
            bindIsPublicAttachment();
            bindIsEmailAttachment();
            bindDragZoomedImage();
            bindImageRotation();
            bindRenameAttachment();
        };

        const bindDragZoomedImage = () => {
            $imageTarget.on(`mousedown.${_identifier}`, function (e) {
                $zooming.isDragging = true;
                $imageTarget.css('cursor', 'grabbing');

                $zooming.startX = e.pageX - $imageContainer.offset().left;
                $zooming.startY = e.pageY - $imageContainer.offset().top;
                $zooming.scrollLeft = $imageContainer.scrollLeft();
                $zooming.scrollTop = $imageContainer.scrollTop();

                e.preventDefault();
            });

            $($documentElement).on(`mousemove.${_identifier}`, function (e) {
                if (!$zooming.isDragging) return;

                const x = e.pageX - $imageContainer.offset().left;
                const y = e.pageY - $imageContainer.offset().top;
                const walkX = x - $zooming.startX;
                const walkY = y - $zooming.startY;

                $imageContainer.scrollLeft($zooming.scrollLeft - walkX);
                $imageContainer.scrollTop($zooming.scrollTop - walkY);
            });

            $($documentElement).on(`mouseup.${_identifier}`, function () {
                $zooming.isDragging = false;
                $imageTarget.css('cursor', 'grab');
            });
        };

        const bindCloseDialogButton = () => {
            $imageBoxDialog.find('button.close-js').on(`click.${_identifier}`, closeDialog);
        };

        const refreshAttachments = ($changedAttachmentLists) => {
            $(this).removeAttr("target");
            const $attachment = $(this);
            const encodedAttachmentList = encodeURIComponent(JSON.stringify($changedAttachmentLists));
            const params = `fileNames=${encodedAttachmentList}&action=attachmentDialogAction`;

            ajaxSubmit(
                $attachment,
                getAttachmentsPostParams($attachment, params)
            );
        };

        const bindRenameAttachment = () => {
            $($documentElement).on(`click.${_identifier}`, '.imageViewerAttachmentName', function() {
                const title = $(this).text().trim();
                const extension = $(this).attr('extension');
                const allowChange = $(this).attr('allowChange');
                if ($(this).find('input[name="attachmentName"]').length === 0) {
                    if (!allowChange) {
                        return;
                    }
                    $isInputFieldOn = true;
                    let currentText = $(this).text().trim();
                    let attachmentName = currentText.replace(/\.[^/.]+$/, "");
                    let attachmentNameInput = $('<input type="text" id="attachmentName" maxlength="146" name="attachmentName" data-filename="' + title + '" data-extension="' + extension  + '" data-cy="Attachment_Name" />').val(attachmentName);

                    $(this).html(attachmentNameInput);

                    attachmentNameInput.on(`blur.${_identifier}`, function() {
                        if ($(this).val().trim() === '') {
                            $(this).focus();
                            return;
                        }
                        $filename = $(this).val().trim() + '.' + attachmentNameInput.data('extension').trim();

                        if (allowChange) {
                            $(this).parent()
                                .text($filename)
                                .append($editIcon);
                        }

                        const itemKey = $attachmentListKeys[$currentAttachmentKey];
                        let attachment = $($documentElement).find('.allAttachmentDetails[data-tmpname=' + itemKey + ']');
                        attachment.text($filename);
                        attachment.attr('data-filename', $filename);
                        if ($filename !== '') {
                            $isInputFieldOn = false;
                            if (currentText !== $filename && $isEscapeKeyPressed === false) {
                                saveAttachment();
                                window.parent.displayToastMessage(gettext('Attachment Renamed.'), 0, 800, 300);
                                let newDownloadlink = updateAttachmentLink(itemKey);
                                $imageBoxDialog.find('.download-js').attr('href', `${newDownloadlink}&download=1`);
                            }
                        }
                    }).on(`focus.${_identifier} keyup.${_identifier} change.${_identifier} paste.${_identifier}`, function () {
                        if ($isIframe) {
                            window.parent.validateAttachmentName($(this), 'attachment');
                        } else {
                            validateAttachmentName($(this), 'attachment');
                        }
                    });

                    attachmentNameInput.on(`keydown.${_identifier}`, function(e) {
                        if (e.keyCode === 13) {
                            if ($(this).val().trim() === '') {
                                e.preventDefault();
                                return;
                            }
                            $(this).blur();
                        }
                    });

                    attachmentNameInput.focus();
                }
            });
        };

        const bindDeleteAttachment = () => {
            $($documentElement).find('#attachmentDeleteButton').on(`click.${_identifier}`, () => {
                // Exit early if dialog already visible
                if ($isConfirmDialogOn) {
                    return;
                }

                if ($attachmentList[$attachmentListKeys[$currentAttachmentKey]].showDeleteButton) {
                    let dialogMessage = sprintf(gettext("Are you sure you want to remove attachment %s?"), "<strong>" + $attachmentList[$attachmentListKeys[$currentAttachmentKey]].filename + "</strong>");
                    let returnDialog;

                    if ($isIframe) {
                        returnDialog = window.parent.createDialog("confirm", gettext(dialogMessage), gettext("Confirm"));
                    } else {
                        returnDialog =  window.createDialog("confirm", gettext(dialogMessage), gettext("Confirm"));
                    }

                    $isConfirmDialogOn = true;
                    returnDialog.on(`click.${_identifier}`, ".dialogContinue", function () {
                        $isConfirmDialogOn = false;
                        deleteAttachment();
                        $($documentElement).find('div[class="dialogBox"]').remove();
                    }).on(`click.${_identifier}`, '.dialogClose', function () {
                        $isConfirmDialogOn = false;
                    });
                } else {
                    createDialog("alert", gettext("Sorry, You do not have permission to delete the image"), "Error");
                }
            });
        };

        // see setIdentifier comment to understand why of this method
        const unbindEvents = () => {
            $($documentElement).off(`.${_identifier}`);
            $('body *').off(`.${_identifier}`);
            $($documentElement).off(`.${_identifier}`);
            $($documentElement).find('body *').off(`.${_identifier}`);
        };

        const makeAjaxRequest = (
            url,
            data,
            successCallback,
            errorCallback = (xhr, status, error) => { console.error('AJAX Error:', status, error); }
        ) => {
            $.ajax({
                url: url,
                type: 'POST',
                data: data,
                success: successCallback,
                error: errorCallback
            });
        };

        const deleteAttachment = () => {
            const itemKey = $attachmentListKeys[$currentAttachmentKey];
            const data = {
                'fileHash': itemKey
            };

            const successCallback = (response) => {
                const index = $changedAttachmentLists.findIndex(item => item.itemKey === itemKey);
                if (index !== -1) {
                    $changedAttachmentLists[index].isDeleted = true;
                } else {
                    $changedAttachmentLists.push({
                        itemKey,
                        isDeleted: true
                    });
                }

                $currentAttachmentKey === 0 ? loadNextAttachment() : loadPreviousAttachment();

                delete $attachmentList[itemKey];
                $attachmentListKeys = $attachmentListKeys.filter(item => item !== itemKey);
                if ($attachmentListKeys.length === 0) {
                    refreshAttachments($changedAttachmentLists);
                    $imageBoxDialog.hide();
                    $('body').css('overflow', 'auto');
                }

                $(`table[id="attachmentTable"] tr[id="${itemKey}"]`).remove();
                $(`div[id="attachmentFilesContainer"] div[data-tmpname="${itemKey}"]`).remove();
            }

            makeAjaxRequest(
                '/staff/attachments/delete-attachment',
                data,
                successCallback
            );
        };

        const saveAttachment = async () => {
            const itemKey = $attachmentListKeys[$currentAttachmentKey];
            const attachment = $attachmentList[itemKey];
            if (attachment.filename === '' || !attachment.allowChange) {
                return;
            }

            if (!updateAttachmentState(itemKey) || $isEscapeKeyPressed === true) {
                return;
            }

            const updatedAttachment = $attachmentList[itemKey];

            if (updatedAttachment.filename === '') {
                return;
            }

            const data = {
                'fileHash': itemKey,
                'filename': updatedAttachment.filename,
                'isPublic': updatedAttachment.isPublic,
                'isEmail': updatedAttachment.isEmail,
                'degreeRotationAngle': $rotationAngle
            };

            const successCallback = (response) => {
                $rotationAngle = 0;
                $($documentElement).find(`.icon-mail[data-tmp-name="${itemKey}"]`).toggle(!!data.isEmail);
                $($documentElement).find(`.icon-see[data-tmp-name="${itemKey}"]`).toggle(!!data.isPublic);
            };

            makeAjaxRequest(
                '/staff/attachments/save-attachment',
                data,
                successCallback
            );
        }

        const updateAttachmentLink = (itemKey, date = null) => {
            let originalLink = $attachmentList[itemKey].link;

            // Ensure the link is valid before proceeding
            if (originalLink === '') {
                console.error(`No link found for itemKey: ${itemKey}`);
                return null;
            }

            // Break the URL into its base and query parameters
            let [baseUrl, queryString] = originalLink.split('?');
            if (queryString === '') {
                console.error(`No query parameters found in the URL: ${originalLink}`);
                return null;
            }

            let params = new URLSearchParams(queryString);

            // Update the parameters only if they have values
            if (date !== null) params.set('v', date);
            if ($filename !== '') params.set('filename', $filename);
            // Rebuild the full URL with updated parameters
            const updatedLink = `${baseUrl}?${params.toString()}`;

            // Update the attachment list with the new link
            $attachmentList[itemKey].link = updatedLink;

            return updatedLink;
        };



        const convertSvgToPng = async () => {
            return new Promise((resolve, reject) => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                canvas.width = $imageTarget.width();
                canvas.height = $imageTarget.height();

                fetch($imageTarget.attr('src'))
                    .then(response => response.text())
                    .then(svgText => {
                        const utf8Svg = encodeURIComponent(svgText).replace(/%([0-9A-F]{2})/g, (match, p1) => {
                            return String.fromCharCode('0x' + p1);
                        });
                        const svgBase64 = 'data:image/svg+xml;base64,' + btoa(utf8Svg);

                        const img = new Image();
                        img.onload = () => {
                            ctx.clearRect(0, 0, canvas.width, canvas.height);
                            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                            const base64Image = canvas.toDataURL('image/png');
                            resolve(base64Image);
                        };
                        img.onerror = () => reject(new Error('Failed to load SVG image'));
                        img.src = svgBase64;
                    })
                    .catch(err => reject(err));
            });
        };

        /*
         * As we use css transform to apply the rotation, just inveting the existing image width and height
         * does not work properly. So, we generate a canva image based on the existing one, adjusting
         * the width and height as a new image, according to the rotation.
         */
        const getBase64RotatedImage = async (degree) => {
            try {
                const itemKey = $attachmentListKeys[$currentAttachmentKey];
                const attachment = $attachmentList[itemKey];
                let imgWidth;
                let imgHeight;

                let imageSrc;
                if (attachment.mimeType === 'image/svg+xml' && !$imageTarget.attr('src').startsWith('data:')) {
                    imgWidth = $imageTarget.width();
                    imgHeight = $imageTarget.height();
                    imageSrc = await convertSvgToPng();
                } else {
                    imgWidth = $imageTarget[0].naturalWidth;
                    imgHeight = $imageTarget[0].naturalHeight;
                    imageSrc = $imageTarget.attr('src');
                }

                return new Promise((resolve, reject) => {
                    const imgElement = new Image();

                    imgElement.onload = () => {
                        const rotate = degree !== 0 ? degree * (Math.PI / 180) : 0;
                        const absCos = Math.abs(Math.cos(rotate));
                        const absSin = Math.abs(Math.sin(rotate));
                        const newWidth = imgWidth * absCos + imgHeight * absSin;
                        const newHeight = imgWidth * absSin + imgHeight * absCos;

                        const canvas = document.createElement('canvas');
                        const ctx = canvas.getContext('2d');

                        canvas.width = newWidth;
                        canvas.height = newHeight;

                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                        ctx.translate(canvas.width / 2, canvas.height / 2);
                        ctx.rotate(rotate);
                        ctx.scale(1, 1);
                        ctx.drawImage($imageTarget[0], -(imgWidth / 2), -(imgHeight / 2));
                        ctx.setTransform(1, 0, 0, 1, 0, 0);

                        const base64Image = canvas.toDataURL(attachment.mimeType);

                        resolve(base64Image);
                    }

                    imgElement.onerror = () => reject(new Error('Failed to load image'));
                    imgElement.src = imageSrc;
                });
            } catch (error) {
                console.error('Error processing image:', error);
                throw error;
            }
        }

        const loadPreviousAttachment = async () => {
            if ($currentAttachmentKey === 0 || $isInputFieldOn) return;

            const itemKey = $currentAttachmentKey - 1;
            const previousKey = $attachmentListKeys[itemKey];

            await saveAttachment();
            loadTargetAttachment(previousKey);
        };

        const loadNextAttachment = async () => {
            if ($currentAttachmentKey === $attachmentListKeys.length - 1 || $isInputFieldOn) return;

            const itemKey = $currentAttachmentKey + 1;
            const nextKey = $attachmentListKeys[itemKey];

            await saveAttachment();
            loadTargetAttachment(nextKey);
        };

        const updateAttachmentState = (itemKey) => {

            const oldAttachmentData = $attachmentList[itemKey];
            let newAttachmentData = Object.assign({}, oldAttachmentData);

            //There are some pages that do not have isEmail or isPublic checkboxes.
            const attachEmailElement = $($documentElement).find('.imageViewerAttachmentEmail');
            const attachPublicElement = $($documentElement).find('.imageViewerAttachmentPublic');
            const attachNameElement = $($documentElement).find('.imageViewerAttachmentName');

            if (attachEmailElement.length > 0 && attachEmailElement.css('visibility') !== 'hidden') {
                newAttachmentData.isEmail = attachEmailElement.prop('checked');
            }

            if (attachPublicElement.length > 0 && attachPublicElement.css('visibility') !== 'hidden') {
                newAttachmentData.isPublic = attachPublicElement.prop('checked');
            }

            if (attachNameElement.length > 0 && attachNameElement.css('visibility') !== 'hidden') {
                newAttachmentData.filename = attachNameElement.text().trim();
            }

            const hasChanged = (JSON.stringify(newAttachmentData) !== JSON.stringify(oldAttachmentData)) || $rotationAngle !== 0;

            if (hasChanged) {
                $attachmentList[itemKey] = newAttachmentData;
                if ((oldAttachmentData.isEmail !== newAttachmentData.isEmail ||
                    oldAttachmentData.isPublic !== newAttachmentData.isPublic ||
                    oldAttachmentData.filename !== newAttachmentData.filename ||
                    $rotationAngle !== 0)
                ) {
                    getAttachmentEditChanges(($isEscapeKeyPressed === true || newAttachmentData.filename === '') ? oldAttachmentData : newAttachmentData, itemKey);
                }
            }

            return hasChanged;
        }

        const initialize = (targetAttachmentId) => {
            setIdentifier();
            defineElementObjects();
            loadAttachmentList();
            loadTargetAttachment(targetAttachmentId);
            openDialog();
        };

        /*
         * Everytime the user open the dialog a new plugin instance is initiated by attachments.js
         * It generates multiple binds for the objects causing multiples event trigger for the same thing generating different issues.
         * We generate an internal identifier for the instance to unbind the events once the instance is destroyed to avoid this issue.
         * Using a random number and the current timestamp we guarantee the identifier
         * is always different as the timestamp is based on milliseconds.
         */
        const setIdentifier = () => {
            const timestamp = Date.now();
            const randomPart = Math.floor(Math.random() * 10000);

            _identifier = `${timestamp}${randomPart}`;
        };

        const destroy = () => {
            unbindEvents();
        };

        const defineElementObjects = () => {
            const elementID = $(this).data('elementid') ?? '';
            $imageBoxDialog = $(`#imageBoxDialog_redesigned${elementID}`);
            if (!$imageBoxDialog.length) {
                $documentElement = $(window.parent.document);
                $imageBoxDialog = $documentElement.find('#imageBoxDialog_redesigned');
                $isIframe = true;
            } else {
                $documentElement = $(document)
            }

            $imageTarget = $imageBoxDialog.find('#lightboxImage');
            $imageContainer = $imageBoxDialog.find('.imageCanvas-js');

            $navigationButtons.previous = $imageBoxDialog.find('#attachmentModalPrev button.previous');
            $navigationButtons.next = $imageBoxDialog.find('#attachmentModalNext button.next');
        };

        return this.each(() => {
            try {
                initialize($(this).data('tmpname'));
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Error opening attachments dialog:', error);
                createDialog("alert", "Sorry, it was not possible to open the image viewer", "Error");
            }
        });
    };
})(jQuery);
